[
  { "id": "root", "cx": 105, "cy": 26, "level": 0, "label": "root" },
  { "id": "left-mid", "cx": 72, "cy": 66, "level": 1, "label": "•" },
  { "id": "right-mid", "cx": 138, "cy": 66, "level": 1, "label": "•" },
  { "id": "left-leaf-1", "cx": 47, "cy": 108, "level": 2, "label": "•" },
  { "id": "left-leaf-2", "cx": 92, "cy": 108, "level": 2, "label": "•" },
  { "id": "right-leaf-1", "cx": 118, "cy": 108, "level": 2, "label": "•" },
  { "id": "right-leaf-2", "cx": 163, "cy": 108, "level": 2, "label": "•" }
]
